var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoft4Lengeh5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76 30",
    style: {
      enableBackground: "new 0 0 76 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1,15.4H7.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.8c0.3,0,0.5,0.2,0.5,0.5S10.3,15.4,10.1,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.5,11.4 9.5,18.4 13.1,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,30H0V0h76V30z M1,29h74V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9,25.4H4.4V4.4h11.5V25.4z M5.4,24.4h9.5v-19H5.4V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C39,29.8,38.7,30,38.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C19.7,29.8,19.5,30,19.2,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C57.8,29.8,57.5,30,57.3,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9,15.3h-6.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.5c0.3,0,0.5,0.2,0.5,0.5S51.2,15.3,50.9,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V18C48.2,18.3,48,18.5,47.7,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4,15.3h-6.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.5c0.3,0,0.5,0.2,0.5,0.5S69.7,15.3,69.4,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.6c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5V18C66.7,18.3,66.4,18.5,66.2,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,15.3H26c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.5c0.3,0,0.5,0.2,0.5,0.5S32.7,15.3,32.5,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V18C29.7,18.3,29.5,18.5,29.2,18.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 25.2,
    width: 56,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 3.4,
    width: 56,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoft4Lengeh5);
export default __webpack_public_path__ + "static/media/joft_4_lengeh_5.67be16cb72798adfbd89131bbf354d25.svg";
export { ForwardRef as ReactComponent };